import React, { useContext } from "react";
import styled from "styled-components";
import noInternet from "../../images/noInternet.svg";
import { AutherContext, ToastContext } from "../../Context/Context";
import { InputWrapper, Label, StyledButton } from "./StyledButton";
import ButtonLoader from '../Loader/ButtonLoader';

const Modal = styled.div`
  display: ${(props) => (props.check ? "block" : "none")};
  visiblity: ${(props) => (props.check ? "visible" : "hidden")};
  position: fixed;
  z-index: 1000000;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: scroll;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const DeleteForm = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  box-shadow: 0px 5px 5px rgba(0, 0, 0, 0.2);

  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 375px;
  height: 400px;
  background-color: rgba(255, 255, 255, 1);
  border-radius: 10px;

  align-content: center;
  justify-content: center;
  align-items: center;
`;

export default function NoInternet() {
  const { refetchToken, setRefetchToken, showLoader, setShowLoader } = useContext(AutherContext);
  const { noNet } = useContext(ToastContext);
  if (true) {
    return (
      <Modal check={noNet}>
        <DeleteForm>
          <img alt="noInternet" src={noInternet} />
          <Label className="noInternetTitle">No Internet connection</Label>
          <Label className="noInternetLabel">
            Please check your connection & try again
          </Label>
          <InputWrapper justify="center">
            <StyledButton
              primary
              onClick={() => {
                setShowLoader(true)
                setRefetchToken(!refetchToken);
              }}
            >
              {showLoader ? <ButtonLoader h="20px" w="20px" r="2px" color={'primary'} /> : 'Try again'}
            </StyledButton>
          </InputWrapper>
        </DeleteForm>
      </Modal>
    );
  } else {
    return "";
  }
}
